import ax from "../axios";

class PurchaseOrderService {
  #rootUrl = "/api/purchase-orders";

  static Instance() {
    return new PurchaseOrderService();
  }

  async createPurchaseOrder(request) {
    const result = await ax.post(this.#rootUrl, request);

    return result.data;
  }

  async getTrackingStatuses() {
    const result = await ax.get("/api/purchase-orders/statuses");

    return result.data;
  }

  async getPurchaseOrderById(id) {
    const result = await ax.get(`${this.#rootUrl}/${id}`);

    return result.data;
  }

  async updatePurchaseOrder(id, request) {
    const result = await ax.post(`${this.#rootUrl}/${id}/update`, request);

    return result.data;
  }

  async deletePurchaseOrder(id) {
    return ax.post(`${this.#rootUrl}/${id}/delete`);
  }

  async getPurchaseOrders(request) {
    const result = await ax.post("/api/purchase-orders/all", request);
    return result.data;
  }

  async getPurchaseOrderCounts(request) {
    const result = await ax.post("/api/purchase-orders/counts", request);
    return result.data;
  }

  async searchPurchaseOrdersWithFilters(request) {
    const result = await ax.post("/api/purchase-orders/search", request);
    return result.data;
  }

  async updatePurchaseOrderStatus(id, request) {
    const result = await ax.post(`${this.#rootUrl}/${id}/status/update`, request);

    return result.data;
  }

  async requestShipment(request) {
    const result = await ax.post("/api/purchase-orders/request-shipment", request);

    return result.data;
  }

  async createPurchaseOrderLineItemsAsync(request) {
    const result = await ax.post("/api/purchase-orders/line-items", request);
    return result.data;
  }

  async getPurchaseOrderLineItemsAsync(id) {
    const result = await ax.get(`${this.#rootUrl}/${id}/line-items`);
    return result.data;
  }

  async deletePurchaseOrderLineItemAsync(id, purchaseOrderId) {
    const result = await ax.post(`${this.#rootUrl}/${purchaseOrderId}/line-items/remove/${id}`);
    return result.data;
  }
}

export default PurchaseOrderService.Instance();
